import { render, staticRenderFns } from "./DictionaryWords.vue?vue&type=template&id=7a29b228&scoped=true&"
import script from "./DictionaryWords.vue?vue&type=script&lang=js&"
export * from "./DictionaryWords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a29b228",
  null
  
)

export default component.exports